import React from 'react'

import {LinkButton} from '../linkbutton'
import {Typography} from '../typography'
import AuthorizedUser from './AutorizedUser'
import * as classes from './PassportUser.classes'
import {PassportResponse} from './types'
import {getDefaultAndRestAccounts} from './utils'
import clsx from 'clsx'

export const enum LoginButtonSize {
  S = 's',
  M = 'm',
}

export const enum LoginButtonColor {
  DARK = 'dark',
  LIGHT = 'light',
}

type Props = {
  addUserText?: string
  avatarClassName?: string
  avatarHost: string
  mobile?: boolean
  passport?: PassportResponse
  passportHost: string
  returnPath: string
  showUsername?: boolean
  signInText?: string
  signOutText?: string
  size?: LoginButtonSize
  withoutSignInButton?: boolean
  yui: string
  color?: LoginButtonColor
}

function PassportUser(props: Props): React.ReactElement<Props> | null {
  const {
    addUserText = 'Добавить пользователя',
    avatarClassName,
    avatarHost,
    mobile,
    passport,
    passportHost,
    returnPath,
    showUsername,
    signInText = 'Войти',
    signOutText = 'Выйти',
    withoutSignInButton,
    yui,
    size = LoginButtonSize.M,
    color = LoginButtonColor.LIGHT,
  } = props

  if (passport && passport.accounts && passport.accounts.length > 0) {
    const [defaultAccount, restAccounts] = getDefaultAndRestAccounts(passport.accounts, passport.default_uid)

    return (
      <AuthorizedUser
        account={defaultAccount}
        accounts={restAccounts}
        addUserText={addUserText}
        avatarClassName={avatarClassName}
        avatarHost={`${avatarHost}/get-yapic`}
        canAddMore={passport['can-add-more']}
        mobile={mobile}
        passportHost={passportHost}
        returnPath={returnPath}
        showUsername={showUsername}
        signOutText={signOutText}
        yui={yui}
      />
    )
  }

  if (withoutSignInButton) {
    return null
  }

  return (
    <LinkButton
      aria-label={signInText}
      className={clsx(classes.root, classes[color])}
      href={`${passportHost}/auth?retpath=${returnPath}`}
      shape="circle"
      size="xs"
    >
      <Typography
        group="tight"
        thickness="regular"
        color={color === LoginButtonColor.DARK ? 'invert' : void 0}
        variant={size === LoginButtonSize.S ? 'body2' : 'body1'}
      >
        {signInText}
      </Typography>
    </LinkButton>
  )
}

export default PassportUser
